import { AntDesign } from '@expo/vector-icons';
import { map } from 'lodash';
import React, { useState } from 'react';
import { FlatList, StyleSheet, TouchableOpacity } from 'react-native';
import Modal from 'react-native-modal';
import { LocationProps } from 'src/common/api/response';
import { keyExtractor } from 'src/common/utils/KeyExtractor';
import { Container, RegularText, Row, SearchBox } from 'src/components/bases';
import { IconButton } from 'src/components/buttons';
import { Constants } from 'src/constants/constants';
import { AppColors } from 'src/themes/Colors';
import { metrics, pixelScaler } from 'src/themes/Metrics';
import { EmptyState } from '../EmptyState';

interface Props {
  onClose(): any;
  isVisible: boolean;
  onProvinceSelected: (province: LocationProps) => void;
  provinces: LocationProps[];
  label?: string;
  isLoading: boolean;
  error: any;
}

export const ProvinceModal = ({
  onClose,
  isVisible,
  onProvinceSelected,
  label,
  provinces,
  isLoading,
  error,
}: Props) => {
  const [search, setSearch] = useState('');

  const renderItem = ({ item }: { item: any }) => {
    return <ProvinceItem province={item} onPress={() => onProvinceSelected(item)} />;
  };

  return (
    <Modal
      style={{ paddingVertical: pixelScaler(20), justifyContent: 'flex-start' }}
      onSwipeComplete={onClose}
      hasBackdrop
      onBackButtonPress={onClose}
      onBackdropPress={onClose}
      isVisible={isVisible}>
      <Container paddingTop={metrics.large} flex borderRadius={metrics.borderRadius} backgroundColor={AppColors.white}>
        <Row
          paddingHorizontal={metrics.large}
          style={{
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: metrics.large,
          }}>
          <RegularText fontSize="large" fontWeight="bold" textLang={label} />
          <IconButton icon={<AntDesign name="closecircle" size={pixelScaler(28)} />} onPress={onClose} />
        </Row>
        <Container paddingHorizontal={metrics.large}>
          <SearchBox
            autoFocus={provinces.length > 6}
            editable
            placeholderLang="search"
            value={search}
            onChangeText={setSearch}
          />
          <FlatList
            keyExtractor={keyExtractor}
            data={
              search.length > 0
                ? map(provinces, (province: LocationProps) => {
                    if (province.name.toLowerCase().includes(search.toLowerCase())) {
                      return province;
                    }
                    return null;
                  }).filter(p => p != null)
                : provinces
            }
            ListEmptyComponent={<EmptyState loading={isLoading} error={error} text="locationNotFound" />}
            renderItem={renderItem}
          />
        </Container>
      </Container>
    </Modal>
  );
};

const ProvinceItem = ({ province, onPress }: { province: LocationProps; onPress(): void }) => {
  return (
    <TouchableOpacity
      style={{
        borderBottomWidth: StyleSheet.hairlineWidth,
        borderColor: AppColors.border,
        height: 56,
        justifyContent: 'center',
      }}
      activeOpacity={Constants.ACTIVE_OPACITY}
      onPress={onPress}>
      <RegularText color={AppColors.black}>{province.name}</RegularText>
    </TouchableOpacity>
  );
};
